import { color, exp } from "react-native-reanimated"
import { Styles } from "../utils"
import { StyleSheet, Dimensions } from 'react-native'
import { colorPalette } from "../utils/Styles"
import { CardStyleInterpolators } from "@react-navigation/stack"

const windowDim = Dimensions.get('window').width

// general background layout (container)
export const generalAppContainer = StyleSheet.create({
    desktop: {
        flex:1,
        resizeMode:'cover',
        justifyContent:'center',
        //flexDirection:'row',
    },
    mobile: {
        flex:1,
        resizeMode:'cover',
        justifyContent:'center'
    }
})

export const messagesContainer = StyleSheet.create({
    desktop: {
        flex:1,
        resizeMode:'cover',
        justifyContent:'center',
        flexDirection:'row',
    },
    mobile: {
        flex:1,
        resizeMode:'cover',
        justifyContent:'center'
    }
})

// general rounded floating header container
export const generalFloatingHeader = StyleSheet.create({
    container: {
        flex:1,
        alignSelf:'center',
        alignContent:'center',
        marginTop:50,
        marginBottom:50,
        marginLeft:15,
        marginRight:15,
        backgroundColor: Styles.colorPalette.mainColor,
        borderRadius:8,
        borderWidth: 0,
        // borderColor: Styles.colorPalette.Border,
        shadowColor:colorPalette.Shadow,
        shadowOffset: { width:0, height: 5},
        shadowOpacity: 0.34,
        shadowRadius: 6.27,
        elevation:10,
        width: windowDim / 2,
        minWidth: 400,
        padding: 5,
    },
    text: {
        flex:1,
        fontSize: 25,
        alignSelf:'center',
        fontFamily:'GlobalFontLight',
        color:colorPalette.White,
    }
})

// general rounded view container
export const generalViewContainer = StyleSheet.create({
    desktop: {
        flex:1,
        marginTop:50,
        marginBottom:50,
        marginLeft:15,
        marginRight:15,
        backgroundColor: Styles.colorPalette.White,
        borderRadius:8,
        borderWidth: 0,
        // borderColor: Styles.colorPalette.Border,
        shadowColor:Styles.colorPalette.Shadow,
        shadowOffset: { width:0, height: 5},
        shadowOpacity: 0.34,
        shadowRadius: 6.27,
        elevation:10,
    },
    mobile: {
        flex:1,
        margin:0,
        backgroundColor: Styles.colorPalette.White,
        borderRadius:8,
        borderWidth: 0,
        // borderColor: Styles.colorPalette.Border,
        shadowColor:Styles.colorPalette.Shadow,
        shadowOffset: { width:0, height: 5},
        shadowOpacity: 0.34,
        shadowRadius: 6.27,
        elevation:10,
    }
})

// dashboard styling

export const dashStatsCardContainer = StyleSheet.create({
    desktop: {
        flex:1,
        minWidth:350,
        maxHeight:200,
        backgroundColor: Styles.colorPalette.White,
        borderRadius:8,
        borderWidth: 0,
        // borderColor: Styles.colorPalette.Border,
        shadowColor:Styles.colorPalette.Shadow,
        shadowOffset: { width:0, height: 5},
        shadowOpacity: 0.34,
        shadowRadius: 3,
        elevation:10,
    },
    mobile: {
        flex:1,
        minWidth:350,
        maxHeight:200,
        borderRadius:8,
        borderBottomLeftRadius: 8,
        borderColor: Styles.colorPalette.Dark
    }
})

export const dashboardCards = StyleSheet.create({
    cardContainer: {
        flex:1,
        flexGrow:1,
        flexDirection:'row', 
        flexWrap:'wrap',
        justifyContent:'center',
        alignItems:'flex-start',
    },
})

export const dashStatsCardHeaderContainer = StyleSheet.create({
    desktop: {
        justifyContent:'center',
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
    }, 
    mobile: {
        justifyContent:'center',
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
    }
})

export const dashStatsCardHeaderText = {
    fontSize: 25,
    fontFamily: 'GlobalFontRegular',
}

export const dashStatsCardBody = {
    flex:2,
    flexDirection:'row',
    alignItems:'center'
}

export const dashStatsDataContainer = {
    flex:1,
    flexDirection:'column',
    justifyContent:'center',
    alignItems:'center',
    paddingRight: 10,
}

export const dashStatsTextHeader = {
    fontStyle: 'italic',
    fontFamily: 'GlobalFontRegular',
    paddingBottom: 20,
    fontSize: 20,
}

export const dashStatsText = {
    fontSize: 40,
    fontFamily: 'GlobalFontLight'
}

export const dashStatIconContainer = {
    flex:1,
    padding:30,
}

export const dashStatIconImage = {
    fontSize:1000,
}

//Viewing History
export const dashViewingHistoryBody = {
    flex:10,
    // flexDirection:'column',
    //justifyContent:'center',
}

export const dashViewingHistoryText = {
    fontFamily: 'GlobalFontLight'
}


// header formatting
export const dashSectionHeaderContainer = {
    flex:1,
    padding:30,
}

export const dashSectionHeaderText = {
    flex:1,
    fontSize: 30,
    alignSelf:'center',
    fontFamily:'GlobalFontBold',
}

// Profile card styling
export const profileCardContainer = StyleSheet.create ({
    desktop: {
        // flex:1,
        minWidth:300,
        maxHeight: 450,
        // marginTop:50,
        // marginBottom:50,
        // marginLeft:15,
        // marginRight:15,
        backgroundColor: Styles.colorPalette.White,
        borderRadius:8,
        borderWidth: 0,
        // borderColor: Styles.colorPalette.Border,
        shadowColor:Styles.colorPalette.Shadow,
        shadowOffset: { width:0, height: 5},
        shadowOpacity: 0.34,
        shadowRadius: 6.27,
        elevation:10,
    }
})

export const profileCardText = StyleSheet.create ({
    all: {
        fontSize: 15,
        fontFamily: 'GlobalFontRegular',
    }
})

// NEW profile card
export const profileCard = StyleSheet.create({
    container: {
        flex:1,
        maxHeight:400,
        minWidth:250,
        maxWidth:250,
        backgroundColor: colorPalette.White,
        borderRadius:8,
        borderWidth: 0,
        margin:5,
        // borderColor: Styles.colorPalette.Border,
        shadowColor:Styles.colorPalette.Shadow,
        shadowOffset: { width:0, height: 5},
        shadowOpacity: 0.34,
        shadowRadius: 6.27,
        elevation:10,
    },
    containerMobile: {
        flex:1,
        maxHeight:300,
        minHeight:300,
        minWidth: windowDim / 2.5,
        backgroundColor: colorPalette.White,
        borderRadius:8,
        borderWidth: 0,
        margin:5,
        // borderColor: Styles.colorPalette.Border,
        shadowColor:Styles.colorPalette.Shadow,
        shadowOffset: { width:0, height: 5},
        shadowOpacity: 0.34,
        shadowRadius: 6.27,
        elevation:10,
    },
    headerContainer: {
        flex:1,
        alignItems:'center',
        justifyContent:'center',
    },
    headerText: {
        fontSize: 18,
        fontFamily: 'GlobalFontBold',
        alignSelf:'center'
    },
    bodyContainer: {
        flex:3,
        alignItems:'center'
    },
    imageContainer: {
        flex: 1,
        resizeMode:'contain',
        minWidth: 200,
        minHeight: 300,
    },
    imageContainerMobile: {
        flex: 1,
        resizeMode:'contain',
        minWidth: windowDim / 2.5,
    },
    footerContainer: {
        flex:1,
        flexDirection:'row',
        // alignItems:'center',
        // justifyContent:'center',
    }, 
    footerLeft: {
        flex:1,
        alignItems:'center',
        justifyContent:'center',
    },
    footerBody: {
        flex:2,
        alignItems:'center',
        justifyContent:'center',
    },
    footerRight: {
        flex:1,
        alignItems:'center',
        justifyContent:'center',
    },
    footerText: {
        fontSize: 15,
        fontFamily: 'GlobalFontRegular',
    },
})

// Full profile styling 
export const FullProfileHeaderContainer = StyleSheet.create({
    all: {
        flex:1,
        flexDirection:'column',
        alignItems:'center',
        padding:20,
    }
})

export const FullProfileGeneral = StyleSheet.create({
    messagesContainer: {
        flex:1,
        marginTop:50,
        marginBottom:50,
        marginLeft:15,
        marginRight:15,
        backgroundColor: Styles.colorPalette.White,
        borderRadius:8,
        borderWidth: 0,
        // borderColor: Styles.colorPalette.Border,
        shadowColor:Styles.colorPalette.Shadow,
        shadowOffset: { width:0, height: 5},
        shadowOpacity: 0.34,
        shadowRadius: 6.27,
        elevation:10,
    },
    savedContainer: {
        flex:2,
        marginTop:50,
        marginBottom:50,
        marginLeft:15,
        marginRight:15,
        backgroundColor: Styles.colorPalette.White,
        borderRadius:8,
        borderWidth: 0,
        // borderColor: Styles.colorPalette.Border,
        shadowColor:Styles.colorPalette.Shadow,
        shadowOffset: { width:0, height: 5},
        shadowOpacity: 0.34,
        shadowRadius: 6.27,
        elevation:10,
    },
    defaultPicIcon: {
        color: Styles.colorPalette.Dark,
    },
    header: {
        fontFamily: 'GlobalFontRegular',
    },
    catchphrase: {
        fontFamily: 'GlobalFontRegular',
        textAlign:'center',
    },
    text: {
        flex:1,
        fontFamily: 'GlobalFontLight',
        padding:5,
    }
})

export const FullProfilePersonalInfoGroup = StyleSheet.create({
    container: {
        flex:1,
        flexDirection:'row',
        alignItems:'flex-start',
        //flexWrap:'wrap',
        justifyContent:'center',
    },
    items: {
        //width: '25%', 
        flex:1,
        alignItems:'flex-start',
        marginRight:5,
        padding:10,

    },
    text: {
        flex:1,
        fontFamily:'GlobalFontLight',
    }
})



// MESSAGES STYLINGS
export const MessagesListBody = StyleSheet.create({
    all: {
        flex: 5,
        marginLeft: 10,
        alignItems: 'flex-start'
    }
})

export const MessagesListText = StyleSheet.create({
    all: {
        fontFamily: 'GlobalFontRegular'
    }
})

// Button styling 
export const ButtonStyling = StyleSheet.create({
    PrimaryButtonContainerStyle: {
        backgroundColor: Styles.colorPalette.mainColor,
        paddingVertical: 8,
        width: windowDim / 1.3,
        maxWidth: 300,
        borderRadius: 15,
        alignSelf:'center',
        margin:5,
    },
    PrimaryButtonText: {
        color: colorPalette.White,
        fontSize: 20,
        //textTransform: 'uppercase',
        textAlign: 'center',
        fontFamily: 'GlobalFontRegular',
    },
    DarkButtonContainerStyle: {
        backgroundColor: Styles.colorPalette.Dark,
        paddingVertical: 8,
        width: windowDim / 1.3,
        maxWidth: 300,
        borderRadius: 15,
        alignSelf:'center',
        margin:5,
    },
    DarkButtonText: {
        color: colorPalette.White,
        fontSize: 20,
        //textTransform: 'uppercase',
        textAlign: 'center',
        fontFamily: 'GlobalFontRegular',
    },
})

// container for hold the messages list and splitting the view with the actual chat box
export const messagesListContainer = StyleSheet.create({
    desktop: {
        flex:1,
        flexDirection: 'row',
        marginTop:50,
        marginBottom:50,
        marginLeft:15,
        marginRight:15,
        backgroundColor: Styles.colorPalette.White,
        borderRadius:8,
        borderWidth: 0,
        // borderColor: Styles.colorPalette.Border,
        shadowColor:Styles.colorPalette.Shadow,
        shadowOffset: { width:0, height: 5},
        shadowOpacity: 0.34,
        shadowRadius: 6.27,
        elevation:10,
    },
    mobile: {
        flex:1,
        margin:0,
        backgroundColor: Styles.colorPalette.White,
        borderRadius:8,
        borderWidth: 0,
        // borderColor: Styles.colorPalette.Border,
        shadowColor:Styles.colorPalette.Shadow,
        shadowOffset: { width:0, height: 5},
        shadowOpacity: 0.34,
        shadowRadius: 6.27,
        elevation:10,
    }
})

// SEARCH SCREEN
// container for holding the search screen - floating in desktop mode
export const searchScreenContainer = StyleSheet.create({
    desktop: {
        flex:1,
        flexDirection: 'row',
        marginTop:50,
        marginBottom:50,
        marginLeft:15,
        marginRight:15,
        backgroundColor: Styles.colorPalette.White,
        borderRadius:8,
        borderWidth: 0,
        // borderColor: Styles.colorPalette.Border,
        shadowColor:Styles.colorPalette.Shadow,
        shadowOffset: { width:0, height: 5},
        shadowOpacity: 0.34,
        shadowRadius: 6.27,
        elevation:10,
    },
    mobile: {
        flex:1, 
        flexGrow:1,
        margin:0,
        // padding:10,
        backgroundColor: Styles.colorPalette.White,
        borderRadius:8,
        borderWidth: 0,
        // borderColor: Styles.colorPalette.Border,
        shadowColor:Styles.colorPalette.Shadow,
        shadowOffset: { width:0, height: 5},
        shadowOpacity: 0.34,
        shadowRadius: 6.27,
        elevation:10,
    },
    mobileScroll: {
        flex:1,
        flexGrow:1,
        flexDirection:'row', 
        flexWrap:'wrap',
        justifyContent:'center',
        alignItems:'flex-start',
    }
})

// Search screen options 
export const searchOptions = StyleSheet.create({
    modalWebContainer: {
        flex:1,
        // marginTop:50,
        // marginBottom:50,
        // marginLeft:15,
        // marginRight:15,
        backgroundColor: Styles.colorPalette.White,
        borderRadius:8,
        borderWidth: 0,
        shadowColor:Styles.colorPalette.Shadow,
        shadowOffset: { width:0, height: 5},
        shadowOpacity: 0.34,
        shadowRadius: 6.27,
        elevation:10,
    },
    tabStyle: {
        backgroundColor: colorPalette.White
    },
    tabTextStyle: {
        color: colorPalette.Black,
        fontFamily: 'GlobalFontRegular',
    },
    activeTabStyle: {
        backgroundColor: colorPalette.mainColor
    },
    activeTabTextStyle: {
        fontSize: 20,
        color: colorPalette.Black,
        fontFamily: 'GlobalFontBold',
    },
    optionsContainerWithinTab: {
        flex:1, 
        flexGrow:1,
        flexDirection:'row', 
        flexWrap:'wrap',
        justifyContent:'center',
        alignItems:'flex-start',
        margin:0, 
        padding:20
    },
    optionsContainerWithinTabMobile: {
        flexDirection:'column', 
        justifyContent:'center',
        alignItems:'center',
        margin:40, 
        padding:20
    },
    individualOptionsContainer: {
        margin: 10,
        width: 300,
    },
    individualOptionsContainerMobile: {
        alignSelf: 'center',
        margin: 20,
        width: 300,
    },
    optionsLabel: {
        fontFamily: 'GlobalFontRegular',
        fontSize: 20,
    },
    optionsStyle: {
        width: 300,
        height: 30,
    },

})

// Saved Screen Styling 
export const SavedScreenStyle = StyleSheet.create({
    container: {
        flex:1,
        flexDirection:'row',
    },
    desktopListContainer: {
        flex:1,
        //flexDirection: 'row',
        marginTop:50,
        marginBottom:50,
        marginLeft:15,
        marginRight:15,
        backgroundColor: Styles.colorPalette.White,
        borderRadius:8,
        borderWidth: 0,
        // borderColor: Styles.colorPalette.Border,
        shadowColor:Styles.colorPalette.Shadow,
        shadowOffset: { width:0, height: 5},
        shadowOpacity: 0.34,
        shadowRadius: 6.27,
        elevation:10,
    },
    mobileListContainer: {
        flex:1, 
        flexGrow:1,
        margin:0,
        // padding:10,
        backgroundColor: Styles.colorPalette.White,
        borderRadius:8,
        borderWidth: 0,
        // borderColor: Styles.colorPalette.Border,
        shadowColor:Styles.colorPalette.Shadow,
        shadowOffset: { width:0, height: 5},
        shadowOpacity: 0.34,
        shadowRadius: 6.27,
        elevation:10,
    },
})

export const GridComponentStyling = StyleSheet.create({
    container: {
        flex:1,

    },
    row: {
        flex:1,
        flexDirection:'row',
        justifyContent:'flex-start',
        alignItems:'center',
        borderBottomWidth:1,
        borderBottomColor:colorPalette.Dark,  
    },
    rowItem: {
        paddingLeft:10,
    },
    x: {},
})